import React from 'react';
import PropTypes from 'prop-types';

import { v4 as uuidv4 } from 'uuid';

import withMessages from 'component-utilities/intl';

import styles from './Toggles.scss';

const BASE_KEY = 'components.toggles';

const TYPES = {
    NORMAL: 'NORMAL',
    NORMAL_WITH_TEXT: 'NORMAL_WITH_TEXT',
    LOCKED_WITH_TEXT: 'LOCKED_WITH_TEXT',
};

export { TYPES };

function Component({ type, isChecked, onToggle, getMessage, isDisabled }) {
    const componentUUID = uuidv4();
    const localizedMessage = message => getMessage(`${BASE_KEY}.${message}`);

    const inputAttributes = {
        checked: isChecked ? 'checked' : '',
        onClick: isDisabled ? null : onToggle,
        id: componentUUID,
        role: 'presentation',
        className: styles[`toggle-${type === TYPES.LOCKED_WITH_TEXT ? 'locked' : 'normal'}`],
        type: 'checkbox',
        onChange: () => {},
    };

    let sliderAttributes = {
        className: styles.slider,
        style: isDisabled ? { cursor: 'not-allowed' } : null,
        'data-status': isChecked ? 'enabled' : 'disabled',
    };

    if (type === TYPES.NORMAL_WITH_TEXT) {
        sliderAttributes = {
            ...sliderAttributes,
            'data-on': localizedMessage('enabled'),
            'data-off': localizedMessage('disabled'),
        };
    } else if (type === TYPES.LOCKED_WITH_TEXT) {
        sliderAttributes = {
            ...sliderAttributes,
            'data-on': localizedMessage('enabled'),
            'data-off': localizedMessage('locked'),
            'data-status': isChecked ? 'enabled' : 'locked',
        };
    }

    return (
        <span className={styles[`toggle-container${isDisabled ? '-inactive' : ''}`]} data-toggles>
            <label htmlFor={componentUUID} className={styles.toggle} style={{ cursor: 'not-allowed' }}>
                <input {...inputAttributes} />
                <div {...sliderAttributes} data-action="toggle-status" />
            </label>
        </span>
    );
}

Component.propTypes = {
    type: PropTypes.oneOf(Object.keys(TYPES).map(key => TYPES[key])).isRequired,
    isChecked: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    getMessage: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
};

Component.defaultProps = {
    isDisabled: false,
};

const TogglesGenerator = withMessages(Component);

export default TogglesGenerator;
